import React from 'react';

import { RowRoot, IconSlot, TextBlock, Label, Value } from './styles';

export interface DescriptionRowProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Ícone à esquerda (slot ~24px, outline, herda currentColor). */
  icon?: React.ReactNode;
  /** Rótulo (negrito). */
  label: React.ReactNode;
  /** Valor (regular). */
  value: React.ReactNode;
  /** Exibe o divisor pontilhado abaixo do item. @default true */
  divider?: boolean;
}

/**
 * DescriptionRow — item de "par rotulado": ícone + rótulo (negrito) + valor,
 * com divisor pontilhado opcional abaixo.
 *
 * Átomo genérico (sem regra de negócio): quem monta a lista decide os ícones,
 * a ordem e desliga o `divider` do último item. Usado em resumos/descrições.
 *
 * @example
 * <DescriptionRow icon={<PinIcon />} label="Local" value="Refeitório Fundos" />
 * <DescriptionRow label="Total" value="R$ 120,00" divider={false} />
 */
export const DescriptionRow = ({
  icon,
  label,
  value,
  divider = true,
  ...rest
}: DescriptionRowProps): React.ReactElement => (
  <RowRoot $divider={divider} {...rest}>
    {icon && <IconSlot aria-hidden="true">{icon}</IconSlot>}
    <TextBlock>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </TextBlock>
  </RowRoot>
);

export default DescriptionRow;
